import PublishView from './PublishView';

export default PublishView;
